import React, { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';
import Footer from '../Footer';
import getDeviceType from '../../../../common/utils/getDeviceType';
import DesktopScreen from '../DesktopScreen';
import Analytics from '../../../../common/utils/analyticsUtil';
import { connect } from 'react-redux';
import OyoChatWithDeviceId from '../../components/OyoChatWithDeviceId';
import getCookieValue from '../../../src/utils/getCookieValue';
import { setItemInPersistentStore } from '../../utils/Persist';
import { SAVE_USER_DETAILS_ON_AUTO_LOGIN } from '../../actionTypes';
import isEmpty from 'lodash/isEmpty';
import isL1RevampEnabled from '../../utils/isL1RevampEnabled';
class GuestUserDashboard extends Component {
  constructor(props) {
    super(props);
    this.getDeviceType = getDeviceType();
    this.state = {
      isDesktopBrowser: window.matchMedia('(max-width: 1280px)').matches ? false : true
    }
  }

  componentDidMount() {
    // Max Width in Landscape View is of Galax Tab ie 1280
    // https://css-tricks.com/snippets/css/media-queries-for-standard-devices/
    const mediaQuery = '(max-width: 1280px)';
    this.mediaQueryList = window.matchMedia(mediaQuery);
    if (this.mediaQueryList.addEventListener) {
      this.mediaQueryList.addEventListener('change', this.onWindowChange);
    }
    const { userDetails, language } = this.props;
    let details = {};
    if (!isEmpty(userDetails)) {
      details = userDetails
    } else {
      const USER_COOKIE_READABLE = 'uifReadable';
      const data = getCookieValue(USER_COOKIE_READABLE)
      if (!isEmpty(data)) { details = JSON.parse(Buffer.from(data, 'base64').toString('utf8')); }
      if (!isEmpty(details)) {
        setItemInPersistentStore('user_details', details);
        this.props.dispatch({ type: SAVE_USER_DETAILS_ON_AUTO_LOGIN, payload: details })
      }
    }
    if (details.id) {
      Analytics.setUserId(String(details.id));
    }
    if (details.team) {
      Analytics.registerProperties({ user_role: String(details.team) });
    }
    if (details.email) {
      Analytics.registerProperties({ email: String(details.email) });
    }
    if (details.phone) {
      const phone_code = details.country_code ? String(details.country_code).substr(1) : '';
      Analytics.registerProperties({ phone: phone_code + String(details.phone) });
    }
    if (language) {
      Analytics.registerProperties({ Language: String(language) });
    }
  }

  componentWillUnmount() {
    if (this.mediaQueryList && this.mediaQueryList.removeEventListener) {
      this.mediaQueryList.removeEventListener('change', this.onWindowChange);
    }
  }

  onWindowChange = event => {
    if (event.matches) {
      this.setState({
        isDesktopBrowser: false
      });
    } else {
      this.setState({
        isDesktopBrowser: true
      });
    }
  }

  render() {
    const { component, path, hideFooter, global } = this.props;
    const { isDesktopBrowser } = this.state;
    if (this.getDeviceType.isDesktopBrowser || isDesktopBrowser) {
      return <DesktopScreen />
    }
    return <>
      {this.props.chatEnable && <OyoChatWithDeviceId
        hideFloatingRedButton={isL1RevampEnabled({globalInfo: global.globalInfo, globalInfoDataAvailable: global.globalInfoDataAvailable})}
        startChatWithExternalIntent={this.props.startChatWithExternalIntent}
      />}
      <Route component={component} path={path} />
      {!hideFooter && <Footer />}
    </>
  }
}

const mapStateToProps = state => ({
  userDetails: state.dashboard.user_details,
  language: state.dashboard.language,
  chatEnable: state.global.globalInfo.oyo_360_chat_enabled,
  startChatWithExternalIntent: state.dashboard.startChatWithExternalIntent,
  global: state.global
})

export default withRouter(connect(mapStateToProps)(GuestUserDashboard));
